var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F97AA",
    d: "m11.666 12.792 1.438-1.438L10.04 8.25V3.917H8v5.208zM9 17.667a8.4 8.4 0 0 1-3.368-.678 8.8 8.8 0 0 1-2.76-1.861 8.7 8.7 0 0 1-1.861-2.763A8.5 8.5 0 0 1 .333 8.99q0-1.8.679-3.385a8.6 8.6 0 0 1 1.864-2.762A8.7 8.7 0 0 1 5.64 1 8.6 8.6 0 0 1 9.01.333q1.8 0 3.386.672a8.6 8.6 0 0 1 2.757 1.845 8.6 8.6 0 0 1 1.843 2.76 8.6 8.6 0 0 1 .671 3.392A8.5 8.5 0 0 1 17 12.368a8.63 8.63 0 0 1-4.608 4.62A8.5 8.5 0 0 1 9 17.667m.01-2.042q2.76 0 4.687-1.937t1.928-4.698-1.928-4.687T9.01 2.375 4.312 4.303 2.375 8.99t1.937 4.698 4.698 1.937"
  })));
};
export default SvgClock;